export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_15.25f552f1.jpg";